import { Minus, Plus } from 'lucide-react';
import { useState } from 'react';

const FAQ = () => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const faqItems = [
    {
      question: 'Who is AITOS Labs LLC?',
      answer:
        'AITOS Labs LLC is a Wyoming holding company for Print-on-Demand brands. We build, own, and operate a portfolio of POD brands (currently Elzary and Avyra Atlas), and also offer the same operating stack to outside POD sellers as a managed service.',
    },
    {
      question: 'Which brands does AITOS operate?',
      answer:
        'Two brands are currently active in the portfolio: Elzary (POD apparel & lifestyle) at elzary.com, and Avyra Atlas (Print-on-Demand lifestyle) at avyraatlas.com. Each brand entity owns its IP; AITOS operates each brand under a long-term operating arrangement.',
    },
    {
      question: 'Will you operate my POD brand?',
      answer:
        'Yes — through our managed-operations tier. We start with a 2-week audit, then design an operating agreement scoped to your goals. Capacity is intentionally capped to keep quality high.',
    },
    {
      question: 'What does the AITOS storefront stack look like?',
      answer:
        'Brands we operate ourselves (Elzary and Avyra Atlas) run on our own in-house storefront — custom-built, fully owned, no Shopify lock-in. Marketplace distribution covers Etsy, Amazon, and eBay. Fulfillment is routed through Printify, Printful, and Gelato.',
    },
    {
      question: 'Can you build a store for me — and do you support Shopify?',
      answer:
        'Yes. Under our Build / Operate tiers we set up your storefront two ways: (1) on the AITOS in-house source code (same stack as Elzary and Avyra Atlas), or (2) on Shopify if you prefer that ecosystem. We then connect it to Etsy / Amazon / eBay and the fulfillment partners. You pick the stack; we operate it.',
    },
    {
      question: 'How is AI used in your stack?',
      answer:
        'AI assists design generation, listing copy and SEO, customer-service drafting, demand forecasting, and reviews triage. Humans run the brand; AI compresses the operational cost.',
    },
    {
      question: 'How long until I see results from a managed engagement?',
      answer:
        'Most brands see operational improvements within the first 60 days (response times, listing coverage). Revenue impact typically follows within 1–2 quarters.',
    },
    {
      question: 'What about my data?',
      answer:
        'We comply with GDPR and CCPA. Customer data is processed under a DPA; sellers retain full ownership of brand and customer data.',
    },
    {
      question: 'How does pricing work?',
      answer:
        'Audits are flat-fee. Managed operations are a retainer + revenue share, scoped at the end of the audit. Build engagements are custom.',
    },
  ];

  const toggleItem = (index: number) => {
    setOpenItems((prev) =>
      prev.includes(index) ? prev.filter((item) => item !== index) : [...prev, index]
    );
  };

  return (
    <section className="py-20 px-6 bg-black" id="faq">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-purple-400 text-xl mb-4 tracking-widest">FAQ</h2>
          <h3 className="text-5xl font-bold mb-3">Frequently Asked Questions</h3>
          <p className="text-gray-300">
            What POD sellers, partners, and investors most often ask about AITOS Labs LLC.
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={`${index + 1}`} className="border border-gray-800 rounded-lg overflow-hidden">
              <button
                type="button"
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                onClick={() => toggleItem(index)}
              >
                <span className="text-lg font-medium">{item.question}</span>
                {openItems.includes(index) ? <Minus size={20} /> : <Plus size={20} />}
              </button>
              {openItems.includes(index) && (
                <div className="px-6 pb-6">
                  <p className="text-gray-300">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
